module.exports = __webpack_public_path__ + "static/media/2_6.92174a8f.png";